<template>
    <v-dialog v-model="dialog_connection_error"
      width="420"
      class="neu-glow"
    >
      <v-card class="red neu-glow">
        <v-card-title class="text-h4 mb-4 font-weight-bold">
          {{$t(page+'.Connection Error')}}
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_connection_error = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{$t(page+'.Close')}}</span>
            </v-tooltip>        
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <div class="text-h6">
            {{$t(page+'.Connection missing or Overloaded')}}:
            <br />
            {{$t(page+'.Please wait few seconds and retry')}}.
            <br><br>
            {{$t(page+'.If problem persist, pls contact Booking service via Whatsapp')}}
          </div>
          <div class="text-center mt-6">
            <v-btn large color="success" :href="'https://wa.me/'+whatsappNumber">
              <v-icon large  class="white--text">mdi-whatsapp</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>           
</template>
<script>
export default {
    props:['value','number'],
    data () {
    return {
      dialog:false
    }},
}
</script>